import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export enum FormDetailsReportFields {
  id = 'id',
  formName = 'formName',
  formId = 'formId',
  respondentId = 'respondentId',
  respondentImageId = 'respondentImageId',
  respondentEmail = 'respondentEmail',
  respondentFirstName = 'respondentFirstName',
  respondentMiddleName = 'respondentMiddleName',
  respondentSuffix = 'respondentSuffix',
  respondentPrefix = 'respondentPrefix',
  respondentLastName = 'respondentLastName',
  respondentFullName = 'respondentFullName',
  respondentFirstNameAndLastName = `concat(respondentFirstName, concat(' ', respondentLastName))`,
  respondentStatus = 'respondentStatus',
  formStatus = 'formStatus',
  teamName = 'teamName',
  submissionDate = 'submissionDate',
  sentDate = 'sentDate',
  source = 'source',
  formResponses = 'formResponses'
}

export const FormDetailsReportSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(FormDetailsReportFields.formId, '', 'Form Id'),
  new ItemPickerModel(FormDetailsReportFields.formName, '', 'Form Name'),
  new ItemPickerModel(FormDetailsReportFields.formStatus, '', 'Form Status'),
  new ItemPickerModel(FormDetailsReportFields.respondentId, '', 'Person Id'),
  new ItemPickerModel(FormDetailsReportFields.respondentFirstName, '', 'Person First Name'),
  new ItemPickerModel(FormDetailsReportFields.respondentMiddleName, '', 'Person Middle Name'),
  new ItemPickerModel(FormDetailsReportFields.respondentLastName, '', 'Person Last Name'),
  new ItemPickerModel(FormDetailsReportFields.respondentSuffix, '', 'Person Suffix'),
  new ItemPickerModel(FormDetailsReportFields.respondentPrefix, '', 'Person Prefix'),
  new ItemPickerModel(FormDetailsReportFields.respondentFullName, '', 'Person Full Name'),
  new ItemPickerModel(FormDetailsReportFields.respondentStatus, '', 'Person Status'),
  new ItemPickerModel(FormDetailsReportFields.respondentEmail, '', 'Person Email'),
  new ItemPickerModel(FormDetailsReportFields.source, '', 'Source'),
  new ItemPickerModel(FormDetailsReportFields.submissionDate, '', 'Submission Date'),
  new ItemPickerModel(FormDetailsReportFields.sentDate, '', 'Sent Date'),
  new ItemPickerModel(FormDetailsReportFields.teamName, '', 'Team Name'),
  new ItemPickerModel(FormDetailsReportFields.formResponses, '', 'All Responses (JSON)')
];
